import dynamic from 'next/dynamic';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/aboutus';

const PCLayout = dynamic(() => import('@/components/AboutUs'), { ssr: false });
const H5Layout = dynamic(() => import('@/componentsH5/AboutUs'), { ssr: false });

export default function AboutUs({ SEO }: any) {
    const { isMobile, useRouter, useLang } = useGlobal();
    const { t } = useLang('aboutus');
    const LayoutCom = isMobile ? H5Layout : PCLayout;
    const { locale } = useRouter();

    return (
        <PageLayout theme="gray">
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            <LayoutCom />
        </PageLayout>
    );
}
